export default __webpack_public_path__ + "static/index_hero_02-f3c7414b8c8255db83bb17954cbee88c.jpg";